<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>订单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class="container" > 
            <div style="height:600px;"> 
                    <p class="green" style="text-align:center;width:100%;">天猫店订单卡单批量推送</p> 
                    <label class="label2" style="margin-top:15px;">天猫店铺</label> 
                    <el-select v-model="data.shopId"  placeholder="请选择天猫店铺" filterable  clearable style="width:300px">  
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>  
                    <el-button type="success" plain style=" margin-left:15px;"  @click="shibie">识别订购状态</el-button>
                    <br>
                    <label class="label2" style="margin-top:15px;vertical-align:top;width:100%;margin-top:15px;">识别天猫店铺卡单订单订购状态</label> 
                        <br>
                    <el-input v-model.trim="data1.orders" rows="6" style="width:100%;" placeholder="请输入天猫店铺订单号进行识别，多个单号以、分隔开" type="textarea"></el-input> 
                    <br> 
                     
                    <div style="width:60%;float:left;text-align:center;margin-top:15px;">
                        <label class="label2" style="  width:95%;margin-left:-5%;">天猫店铺订购失败订单号</label> 
                        <br>
                        <el-input v-model.trim="data.orderOnos1" rows="10" style="width:95%;margin-right:5%;" placeholder="请输入天猫店铺订单号，多个单号以、分隔开" type="textarea"></el-input> 
                        <br>
                        <el-button type="success" style="margin-top:15px;margin-left:-2.5%; font-size:18px;"  @click="operPushTM(-1)">立即推送</el-button>

                    </div> 
                    <div style="width:40%;float:left;text-align:center;margin-top:15px;">
                        <label class="label2" style=" width:95%;margin-left:5%;">天猫店铺订购成功订单号</label> 
                        <br>
                        <el-input v-model.trim="data.orderOnos2" rows="10" style="width:95%;margin-left:5%;" placeholder="请输入天猫店铺订单号，多个单号以、分隔开" type="textarea"></el-input> 
                        <br>
                        <el-button type="success" style="margin-top:15px;margin-left:2.5%; font-size:18px;"  @click="operPushTM(9)">立即推送</el-button>

                    </div>
                    
                   

                </div>  
        </div> 
         
        
          
    </div>
</template>

<script>
import {fetchSelectTM as fetchSelect} from '../../api/member';   5
import {setResultToTM,getOrderDiff} from '../../api/comOrderPush';   


export default {

    data() {
        return {  
            data1:{orders:'',shopId:''},   
            data:{orderOnos1:'',orderOnos2:'',shopId:'',deducFag:'1',orderOno:''},   
            select:{option:'',}, 
            orderList:[],
        };
    },
    created() { 

    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.orderList = [];
        this.getSelect(); 
    },

    methods: {  
         getSelect(){ 
            this.select = {};  
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select, 'option', res.data);  
                }
            });
        },
        shibie(){
            getOrderDiff(this.data1).then(res => {
                if(res.code=='200'){ 
                    this.data.orderOnos1 = res.data.fail;
                    this.data.orderOnos2 = res.data.success;
                    this.$message.success("识别成功");
                }else{
                    this.$message.error( res.message);
                }
            });  
        },
        operPushTM(status){
            if(!this.data.shopId){
                this.$message.error("请选择天猫店铺");
                return;
            } 
            var fag = false;
            if(status==-1){
                if(!this.data.orderOnos1 || this.data.orderOnos1==''){
                this.$message.error("请填写订购失败天猫订单号");
                    fag=true;
                    return;
                }
                if(this.data.orderOnos1.length<17){
                    this.$message.error("请检查失败天猫订单号是否正确");
                    return;
                   fag=true;
                }
            }else{ 
                if(!this.data.orderOnos2  || this.data.orderOnos2==''){
                    this.$message.error("请填写订购成功天猫订单号");
                    return;
                    fag=true;
                }
                if(this.data.orderOnos2.length<17){
                    this.$message.error("请检查订购成功天猫订单号是否正确");
                   fag=true;
                   return;
                }
            }
            if(fag){
                return;
            }
            var that = this;
            that.$confirm('确认批量推送给天猫店铺吗？', '提示', {
                type: 'warning'
            }).then(() => {   
                that.orderList = [];
                if(status==-1){
                    that.orderList = that.data.orderOnos1.split("、");  
                }else{
                    that.orderList = that.data.orderOnos2.split("、");  
                } 
                var len = that.orderList.length; 
                for (let i = 0; i < len; i++) { 
                    setTimeout(() => {  
                        that.pushResultToTM(that.orderList[i].trim(),status);
                    }, 350*i);   
                } 
            });
        }, 
        pushResultToTM(orderOno,status){ 
            if(orderOno && orderOno!='' && orderOno!=undefined){
                this.data.orderOno = orderOno; 
                this.data.status = status;
                setResultToTM(this.data).then(res => {
                    if(res.code=='200'){ 
                        this.$notify({ title: '成功', message: orderOno+'推送执行成功',duration: 1000, type: 'success' });
                    }else{
                        this.$notify({ title: '失败', message:  orderOno+'推送执行失败：'+res.message,duration: 5000, type: 'error' });
                    }
                });``
            }
              
        },
    }
};
</script>

<style scoped> 
 
</style>
